import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/functions';
import { firebase as firebaseConfig } from '../config';

firebase.initializeApp(firebaseConfig);
const firestore = firebase.firestore();
const settings = {};
firestore.settings(settings);

const auth = firebase.auth();

const firestoreServerTimestamp = () =>
  firebase.firestore.FieldValue.serverTimestamp();

export { auth, firebase, firestore, firestoreServerTimestamp };
